import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-labeled-checkbox',
  templateUrl: './labeled-checkbox.component.html',
  styleUrl: './labeled-checkbox.component.scss'
})
export class LabeledCheckboxComponent {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() controlName: string = '';
  @Input() form: FormGroup | null = null;
  @Input() tooltipText?: string;
  @Input() title?: string;
  @Input() cssClass: string = '';
}


